import { render, staticRenderFns } from "./Incident-Detail.vue?vue&type=template&id=5c8f5d9c"
import script from "./Incident-Detail.vue?vue&type=script&lang=js"
export * from "./Incident-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports